// extracted by mini-css-extract-plugin
export var content = "PricingCard-module--content--8eecd";
export var disicon = "PricingCard-module--disicon--54bea";
export var hasDiscountC = "PricingCard-module--hasDiscountC--f9991";
export var isActive = "PricingCard-module--isActive--07f9d";
export var price = "PricingCard-module--price--4becb";
export var priceUnit = "PricingCard-module--priceUnit--fb4ef";
export var priceWrapper = "PricingCard-module--priceWrapper--df003";
export var pricingText = "PricingCard-module--pricingText--ade6f";
export var pricingTextDiscount = "PricingCard-module--pricingTextDiscount--78ca7";
export var pricingTextOrigin = "PricingCard-module--pricingTextOrigin--ae2c6";
export var root = "PricingCard-module--root--e9ec3";
export var tier = "PricingCard-module--tier--af328";
export var tierText = "PricingCard-module--tierText--b9f17";
export var tierUnit = "PricingCard-module--tierUnit--c9963";